export default {
  language: 'Idioma', guest: 'Visitante', login: 'Iniciar sesión',
  'section-game': 'EL JUEGO', 'section-tools': 'HERRAMIENTAS DE GUERRA',
  'nav-home': 'Inicio', 'nav-rules': 'Reglas del juego',
  'nav-factions': 'Facciones', 'nav-campaigns': 'Campañas', 'nav-faqs': 'FAQs',
  'nav-army': 'Constructor de ejércitos', 'nav-missions': 'Cartas de misión',
  'nav-deployment': 'Mapas de despliegue',
  'footer-notice': 'Web alternativa no oficial — no afiliada a StarCraft: The Tabletop Miniatures Game.',
  'footer-contact': 'Contacto:', 'footer-version': 'Versión',
};
